import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE } from '../utils/Utils.js';
import ErrorMessage from '../shared/ErrorMessage.js';
import './VerifyEmail.css';
const VerifyEmail = (props) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");
  const submit = (formData) => {
    const code = formData.get("code");
    const email = formData.get("email");
    console.log("in submit", code, email);

    fetch(`${API_BASE}/api/auth/verify-email`, {
      method: 'POST',
      body: JSON.stringify({code, email, invite_token: props.inviteToken || ""})
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (data.success) {
        localStorage.setItem('zapmanejo_token', data.token);
        localStorage.setItem('zapmanejo_user', JSON.stringify(data.user));
        window.location.reload();
      } else {
        setErrorMessage(data.message);
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  }

  return (
    <form className="VerifyEmailForm" action={submit}>
      <h2>{t("enter_verification_code")}</h2>
      <p>{t("email_sent_to")} {props.email}</p>
      <input type="text" name="code" value={props.code}
              placeholder={t("enter_code_placeholder")} maxLength="6"/>
      <input type="text" name="email" hidden value={props.email}/>
      <button type="submit">{t("send")}</button>
      <ErrorMessage message={errorMessage}/>
      <div className="links">
        <a href="#" onClick={props.onLoginClick}>{t("login")}</a>
      </div>
    </form>
  );
}

export default VerifyEmail;
